import { createApiService } from "@/core/api/apiService";
import type { FormDto } from "../types/formTypes";

export function createFormApiService() {
  const api = createApiService("forms");
  const businessApi = createApiService("businesses");
  const scope = (businessId: string) => `?${new URLSearchParams({ businessId })}`;
  return {
    getAll: (businessId: string, signal?: AbortSignal) =>
      api.get<FormDto[]>(scope(businessId), { signal }),
    getById: (businessId: string, formId: string, signal?: AbortSignal) =>
      api.get<FormDto>(`${encodeURIComponent(formId)}${scope(businessId)}`, { signal }),
    getPinned: (businessId: string, appointmentId: string, formId: string, signal?: AbortSignal) =>
      businessApi.get<FormDto>(`${encodeURIComponent(businessId)}/appointments/${encodeURIComponent(appointmentId)}/forms/${encodeURIComponent(formId)}`, { signal }),
  };
}

export const formApiService = createFormApiService();
